const o={Moengage:"moengage",Ga:"ga",Collector:"collector"};export{o as Services};
